module.exports = "/images/marker.png?a1762c01084237716e9d3a738ad4834a";